export default __webpack_public_path__ + "svg/calendar/2027/4/junio.svg?2b28609a";